<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="20"
  viewBox="0 0 16 20"
  fill="none"
>
  <path
    d="M8.00004 10.8333C9.38075 10.8333 10.5 9.71404 10.5 8.33332C10.5 6.95261 9.38075 5.83332 8.00004 5.83332C6.61933 5.83332 5.50004 6.95261 5.50004 8.33332C5.50004 9.71404 6.61933 10.8333 8.00004 10.8333Z"
    stroke="currentColor"
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M8.00004 18.3333C11.3334 15 14.6667 12.0152 14.6667 8.33332C14.6667 4.65142 11.6819 1.66666 8.00004 1.66666C4.31814 1.66666 1.33337 4.65142 1.33337 8.33332C1.33337 12.0152 4.66671 15 8.00004 18.3333Z"
    stroke="currentColor"
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
